<template>
    <div>
      <div class="questions">
        <h3 class="h3">常见问题</h3>
        <van-collapse v-model="activeNames">
          <van-collapse-item title="售后客服电话？" name="1">在线客服：4009919688</van-collapse-item>
          <van-collapse-item title="提现审核周期？" name="2">提现审核周期为7个工作日</van-collapse-item>
          <van-collapse-item title="提现到账公告？" name="3">申请提现审核周期为7个工作日，转款日期为每月的10号、20号。</van-collapse-item>
        </van-collapse>
      </div>
      <Footer />
      <Floating />
      <wxNoShare />
    </div>
</template>

<script>
    import { Collapse, CollapseItem } from 'vant';

    export default {
      components: {
        [Collapse.name]: Collapse,
        [CollapseItem.name]: CollapseItem
      },
      name: 'questions',
      data() {
        return {
          activeNames: ['1'],
        };
      },
    }
</script>

<style scoped>
  .questions{
    background: #ffffff;
  }
  .questions .h3{
    margin: 0;
    padding: 10px 0;
    text-align: center;
    font-size: 16px;
    font-weight: normal;
  }
</style>



// WEBPACK FOOTER //
// src/views/users/questions.vue